export default formData => ({
    ...Object.assign(...Object.entries(formData).filter(([key]) => '_' !== key[0]).map(([key, value]) => (
        {[key]: value.value}
    )))
});
